// Front end javascript file
// you might want to have everything within one of these bad boys:
// window.addEventListener('load', (event) => { --> code here <-- });